import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageIndustriaAnio.css';
import './PageHighlights.css';

const SECTIONS = [
  {
    title: 'Crecimiento y Declive',
    accent: 'growth',
    cards: [
      {
        stat: '+327%',
        description: 'HCH creci\u00f3 de $13.7M a $58.4M en 6 a\u00f1os \u2014 de canal emergente al #2 en televisi\u00f3n de Honduras.',
      },
      {
        stat: '-35%',
        description: 'Prensa perdi\u00f3 35% de inversi\u00f3n absoluta ($25M \u2192 $16.2M), su participaci\u00f3n cay\u00f3 de 8.9% a 3.7%.',
      },
      {
        stat: '+390%',
        description: 'OOH explot\u00f3 de $5.8M a $28.5M, aumentando su participaci\u00f3n de mercado de 2% a 6.6%.',
      },
    ],
  },
  {
    title: 'Estructura del Mercado',
    accent: 'structure',
    cards: [
      {
        stat: '81.4%',
        description: 'TV domina la publicidad en Honduras \u2014 $353.5M de los $434.1M del mercado total.',
      },
      {
        stat: '54.6%',
        description: 'Los 25 principales anunciantes controlan m\u00e1s de la mitad del mercado \u2014 $237M de $434M.',
      },
      {
        stat: '~50%',
        description: 'El sector bancario domina Prensa, representando aproximadamente la mitad de toda la publicidad impresa.',
      },
      {
        stat: '#1 en 2',
        description: 'Espresso Americano: #1 anunciante en 2 emisoras de radio, top 3 en otras 6 \u2014 el mayor alcance en radio.',
      },
    ],
  },
  {
    title: 'Pol\u00edtica y Gobierno',
    accent: 'political',
    cards: [
      {
        stat: '+6,083%',
        description: 'Partido Libre pas\u00f3 de $86 a $5.3M \u2014 un partido pol\u00edtico es ahora el anunciante #15 a nivel nacional.',
      },
      {
        stat: '18.3%',
        description: 'QhuboTV: 7 entradas de partidos pol\u00edticos representan el 18.3% del presupuesto del canal \u2014 el canal pol\u00edtico.',
      },
      {
        stat: '21.8%',
        description: 'Radio Globo: 21.8% financiado por pol\u00edtica y gobierno. El anunciante #1 es Partido Libre.',
      },
    ],
  },
  {
    title: 'Dominio Multi-Medio',
    accent: 'crossmedia',
    cards: [
      {
        stat: '6+9+6',
        description: 'BAC Credomatic presente en los 6 medios impresos, 9/10 canales de TV y 6/10 emisoras de radio.',
      },
      {
        stat: '$11.7M',
        description: 'Sercom de Honduras abarca 9 canales de TV + 9 emisoras de radio ($11.7M solo en TV).',
      },
      {
        stat: '8 de 10',
        description: 'Corporaci\u00f3n Dinant presente en 8 de 10 canales de TV, totalizando $10M en inversi\u00f3n.',
      },
    ],
  },
  {
    title: 'Datos Sorprendentes',
    accent: 'surprising',
    cards: [
      {
        stat: '$109.3M',
        description: 'Canal 5 por s\u00ed solo supera a los canales #5\u2013#10 combinados ($69.4M) \u2014 captura el 25% de todo el mercado publicitario de Honduras.',
      },
      {
        stat: '21%',
        description: 'Deportes TVC: 21% de su presupuesto proviene de casas de apuestas (Hondubet, Betpro, Betcris, Fantasy League).',
      },
      {
        stat: '+339%',
        description: 'Lotelhsa (loter\u00eda) creci\u00f3 de $3.2M a $14.3M, ahora es el anunciante #3 a nivel nacional.',
      },
      {
        stat: '-45%',
        description: 'Genomma Lab cay\u00f3 de $23.4M a $12.8M, del #1 al #5 \u2014 la mayor ca\u00edda en el mercado.',
      },
    ],
  },
];

function PageHighlights() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="highlights-page">
        <header className="highlights-header">
          <button className="btn-back" onClick={() => navigate('/top-10-prensa')}>
            &#8592; Prensa
          </button>
          <div className="highlights-title-block">
            <h1 className="highlights-title">Datos Clave</h1>
            <p className="highlights-subtitle">
              Hallazgos &middot; Mercado Publicitario Honduras 2019–2025
            </p>
          </div>
          <button className="btn-next" onClick={() => navigate('/gracias')}>
            Siguiente &#8594;
          </button>
          <img
            src={require('../assets/logo-publisearch.png')}
            alt="Publisearch"
            className="header-logo-inline"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          />
        </header>

        <div className="highlights-body">
          {SECTIONS.map((section, si) => (
            <section key={si} className="highlights-section">
              <h2 className={`section-heading section-heading--${section.accent}`}>
                {section.title}
              </h2>
              <div className="highlights-grid">
                {section.cards.map((card, ci) => (
                  <div
                    key={ci}
                    className={`highlight-card highlight-card--${section.accent}`}
                    style={{ animationDelay: `${si * 0.15 + ci * 0.08}s` }}
                  >
                    <div className={`card-accent-bar card-accent-bar--${section.accent}`} />
                    <span className={`card-stat card-stat--${section.accent}`}>
                      {card.stat}
                    </span>
                    <p className="card-description">
                      {(() => {
                        const spaceIdx = card.description.indexOf(' ');
                        const first = card.description.slice(0, spaceIdx);
                        const rest = card.description.slice(spaceIdx);
                        return <><span className="card-lead-word">{first}</span>{rest}</>;
                      })()}
                    </p>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageHighlights;
